import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const New = lazy(() =>
  import(
    /* webpackChunkName: "NewVaccinations" */ /* webpackPrefetch: true */ "./new/page"
  ).then((module) => ({ default: module.Page })),
);

const Review = lazy(() =>
  import(
    /* webpackChunkName: "ReviewVaccinations" */ /* webpackPrefetch: true */ "./review/page"
  ).then((module) => ({ default: module.Page })),
);

export const VaccinationRoutes = () => (
  <Routes>
    <Route path="new" element={<New />} />
    <Route path="review" element={<Review />} />
  </Routes>
);
